"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowDisplayWorker = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const os = require("os");
const vscode_1 = require("vscode");
/* eslint-disable */ // When editing this file, please remove this and fix the linting concerns.
class WindowDisplayWorker {
    constructor() {
        this.pathPlaceholder = os.platform() === 'win32' ? 'C:\\Program Files\\dotnet\\dotnet.exe' : '/usr/local/share/dotnet/dotnet';
        this.pathPrompt = 'Enter the path to the .NET executable. .NET can be installed at aka.ms/dotnet-download';
    }
    showErrorMessage(message, callback, ...items) {
        vscode_1.window.showErrorMessage(message, ...items).then((response) => __awaiter(this, void 0, void 0, function* () { return callback(response); }));
    }
    showWarningMessage(message, callback, ...items) {
        vscode_1.window.showWarningMessage(message, ...items).then((response) => __awaiter(this, void 0, void 0, function* () { return callback(response); }));
    }
    getModalWarningResponse(message, no, yes) {
        return __awaiter(this, void 0, void 0, function* () {
            return vscode_1.window.showWarningMessage(message, { modal: true }, no, yes);
        });
    }
    showInformationMessage(message, callback, ...items) {
        vscode_1.window.showInformationMessage(message).then((response) => __awaiter(this, void 0, void 0, function* () { return callback(response); }));
    }
    copyToUserClipboard(text) {
        return __awaiter(this, void 0, void 0, function* () {
            yield vscode_1.env.clipboard.writeText(text);
        });
    }
    displayPathConfigPopUp() {
        return vscode_1.window.showInputBox({ value: this.pathPlaceholder, prompt: this.pathPrompt, ignoreFocusOut: true });
    }
}
exports.WindowDisplayWorker = WindowDisplayWorker;
//# sourceMappingURL=WindowDisplayWorker.js.map